import * as bd from 'react-basic-design';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { T } from './text';

type InitFailedProps = {
    ex: any;
    onRetry?: () => void;
    modal?: boolean;
    show?: boolean;
    onHide?: () => void;
    hideGoBack?: boolean;
};

export const InitFailed = ({ ex, onRetry, modal, show, onHide, hideGoBack }: InitFailedProps) => {
    const history = useNavigate();
    if (ex instanceof Error) ex = ex.message;
    else if (typeof ex === 'object' && ex.response) ex = ex.response.data;

    const retry = () => {
        if (onRetry) onRetry();
        else {
            window.location.reload();
        }
    };

    const result = (
        <div className="text-center text-secondary-text middle h-100 p-3">
            <div>
                <T as="p" className="alert alert-danger" maxWidth={600}>
                    {ex ?? 'error-in-loading'}
                </T>
                <div>
                    <bd.Flex align="center" gap={2} className="w-100 ">
                        <bd.Button onClick={retry} variant="contained">
                            <T>{onRetry ? 'retry' : 'refresh'}</T>
                        </bd.Button>
                        {!hideGoBack && (
                            <bd.Button variant="outline" onClick={() => history(-1)}>
                                <T>go-back</T>
                            </bd.Button>
                        )}
                    </bd.Flex>
                </div>
            </div>
        </div>
    );

    return !modal ? (
        result
    ) : (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Body>{result}</Modal.Body>
        </Modal>
    );
};
